import { render, staticRenderFns } from "./GrillaPlanesMantenimiento.vue?vue&type=template&id=65e04576&scoped=true&"
import script from "./GrillaPlanesMantenimiento.vue?vue&type=script&lang=ts&"
export * from "./GrillaPlanesMantenimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e04576",
  null
  
)

export default component.exports